import React, { useEffect, useMemo, useState } from "react";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Papa from "papaparse";
import { Link, useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { useAppealsDropdown, useAppealsList } from '../../../query/hooks/QueryHooksAppeals';
import { GetAppealslistCancelToken } from "../../../services/DashBoardServices";
import { RenderLearningMethod } from "../../../utils/CommonGroupingItem";
import { IMAGE_URL, TABLE_DATE_FORMAT, TABLE_DATE_TIME_FORMAT, TABLE_TIME_FORMAT } from "../../../utils/Constants";
import DataTableComponent from "../../common/DataTableComponent";
import { InitialRender } from "../../common/Helper";
import Hover from "../../common/Hover";
import StatusRender, { ColorRender } from "../../systemadministration/usermanagement/CheckRole";

const AppealTable = ({filterIntake = [],filterLearningMethod = [],globalReset,filterSchool,filterLecturer}) => {
    const history = useHistory();
    const { type } = useParams();
    const [urlType, setUrlType] = useState([type.charAt(0).toUpperCase() + type.slice(1)])
    const [search, setSearch] = useState("");
    const [appealList, setAppealList] = useState([]);
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [learningMethod, setLearningMethod] = useState({ arr: [], checkObj: {} });
    const [programme, setProgramme] = useState({ arr: [], checkObj: [] });
    const [storedGlobal,setStoredGlobal] = useState([])
    const [isDropdownFetched,setIsDropdownFetched] = useState(false)
    const [tableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortOrder: "DESC",
        sortKey: "enddate"
    })

         const {
               data: appealDropdownRaw,
           } = useAppealsDropdown({
               viaStatus: urlType,
           });

    const appealDropdown = useMemo(() => ({
        ...appealDropdownRaw,
        intake: appealDropdownRaw.yearsAndIntaks ?? [],
        learningMethod: appealDropdownRaw.intakeType ?? [],
        programme: appealDropdownRaw.programme ?? [],
    }), [appealDropdownRaw]);

    useEffect(() => {
        setUrlType([type.charAt(0).toUpperCase() + type.slice(1)])
    }, [type])

    useEffect(
        () => {
          setStoredGlobal(JSON.parse(localStorage.getItem("globalDashboardFilters")))
        },[filterIntake,filterLearningMethod]
      )
      useEffect(
        () => {
           if(storedGlobal?.intake?.arr.length != 0 && storedGlobal?.intake?.checkObj != undefined && storedGlobal?.intake.checkObj != null){
            var newObj = Object.keys(storedGlobal.intake?.checkObj).map(d => d.replace('globalIntakeintake','intake').concat(` ${storedGlobal.intake.checkObj[d]}`)).map(d => d.split(" "))
            var jjj = newObj.map(d => d[0])
            var iii = newObj.map(d => d[1])
            var newestObj = jjj.map((d,i) => ` ${d} : ${iii[i]}`)
            var finalObj = {}
            var key;
            var value;
            newestObj.forEach(item => {
              var parts = item.split(":")
              key = parts[0]
              value = parts[1]
              key = key.trim()
              value = value.trim()
              if(value == "true"){value = true}
              if(value == "false"){value = false}
              finalObj[key] = value
            })
            let arrayMade = [];
            for(let d of storedGlobal.intake.arr){
              for(let data of appealDropdown.intake){
                if(d == data.value){
                  arrayMade.push(d)
                }
                      }
                  }
                  setIntake({ ...intake, arr: arrayMade, checkObj: finalObj })
              }
              else if (globalReset) {
                  var newObj = intake.checkObj
                  for (let key in newObj) {
                      newObj[key] = false;
                  }
                  setIntake({ arr: [], checkObj: newObj })
              }

          }, [storedGlobal, filterIntake, globalReset, appealDropdown]
      )
    useEffect(
        () => {
            if (storedGlobal?.learningMethod?.arr.length != 0 && storedGlobal?.learningMethod?.checkObj != undefined && storedGlobal?.learningMethod.checkObj != null) {
                var newObj = Object.keys(storedGlobal.learningMethod?.checkObj).map(d => d.replace('globalLearninglearning', 'learning').concat(` ${storedGlobal.learningMethod.checkObj[d]}`)).map(d => d.split(" "))
                var jjj = newObj.map(d => d[0])
                var iii = newObj.map(d => d[1])
                var newestObj = jjj.map((d, i) => ` ${d} : ${iii[i]}`)
                var finalObj = {}
                var key;
                var value;
                newestObj.forEach(item => {
                    var parts = item.split(":")
                    key = parts[0]
                    value = parts[1]
                    key = key.trim()
                    value = value.trim()
                    if (value == "true") { value = true }
                    if (value == "false") { value = false }
                    finalObj[key] = value
                })
                let arrayMade = [];
                for (let d of storedGlobal.learningMethod.arr) {
                    for (let data of appealDropdown.learning) {
                        if (d == data.value) {
                            arrayMade.push(d)
                        }
                    }
                }
                setLearningMethod({ ...learningMethod, arr: arrayMade, checkObj: finalObj })
            }
            else if (globalReset) {
                var newObj = learningMethod.checkObj
                for (let key in newObj) {
                    newObj[key] = false;
                }
                setLearningMethod({ arr: [], checkObj: newObj })
            }

        }, [storedGlobal, filterLearningMethod, globalReset, appealDropdown]
    )

    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("filterStateAppealsDashboard"));
        if (storedFilters) {
            setIntake(storedFilters.intake);
            setLearningMethod(storedFilters.learningMethod);
            setProgramme(storedFilters.programme);
        }
    }, []);

    const requestData = useMemo(() => ({
        page: tableState.page,
        limit: tableState.perPage,
        globalIntake: filterIntake?.newValue?.length > 0 ? filterIntake?.newValue : [],
        globalLearningMethod: filterLearningMethod?.newValue?.length > 0 ? filterLearningMethod?.newValue : [],
        globalSchool: filterSchool?.newValue?.length > 0 ? filterSchool?.newValue : [],
        globalLecturer: filterLecturer?.newValue?.length > 0 ? filterLecturer?.newValue : [],
        viaQualification: programme.arr,
        intake: intake.arr,
        vialearnMethod: learningMethod.arr,
        viaStatus: urlType,
        key: tableState.sortKey,
        sort: tableState.sortOrder,
        exportStaus: false,
        viaSearch: search,
    }), [
        tableState,
        programme,
        intake,
        type,
        urlType,
        filterIntake,
        filterLearningMethod,
        isDropdownFetched,
        filterSchool,
        filterLecturer,
        search,
        learningMethod
    ]);

    const { data: { appealsList, totalRows }, isLoading } = useAppealsList(requestData);

    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "assignmentName",
            sortable: true,
            sortField: "name",
            cell: (row) => (
                <span
                    className="overflow-ellipsis2 overflow-hidden fst_line2"
                    title={row.assignmentName}
                >
                    <Link
                        className="as-text-blue curser textLimit100"
                        to={`/courseAdministration/coursesdetails/${row.intakeID}/assessments/open/assigned/submissionsAndResults/${row.assignmentID}/appealList/${row.student_id}`}
                    >
                        {row.assignmentName ? row.assignmentName : "-"}
                    </Link>
                </span>
            ),
        },
        {
            name: "Full Name",
            selector: "student_name",
            sortable: true,

            cell: (row) => (
                // <span className="textLimit76" title={row.student_name}>
                //   {row.student_name ? row.student_name : "-"}
                // </span>
                <>
                    {row?.student_name ? (
                        <div className="assigned-title-block-new">
                            <div className="assigned-title-itm">
                                <span
                                    className={
                                        "assigned-title-blk  name-icon cat-dark-red " +
                                        ColorRender("lecturer")
                                    }
                                >
                                    {row?.student_profile ? (
                                        <img
                                            src={`${IMAGE_URL}/${row?.student_profile.replaceAll(
                                                "/home/myaie/public_html/",
                                                ""
                                            )}`}
                                            alt="AIE"
                                        />
                                    ) : (
                                        InitialRender([
                                            row?.student_name
                                        ])
                                    )}
                                    <span className={`profile-box-2-status ${row?.student_status ? row.student_status.toLowerCase() == "online" ? "Online" : row.student_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                                        <i className="fas fa-circle"></i>
                                    </span>
                                    <Hover
                                        firstName={row?.student_name}
                                        photo={row?.student_profile}
                                        email={row?.student_email}
                                        mobile={row?.student_mobile}
                                        right={true}
                                        role={"lecturer"}
                                        status={row?.student_status}
                                        activity_status={row?.student_activity_status}
                                    />
                                </span>
                                <p
                                    className="as-text-blue curser textLimit76"
                                    title={row?.student_name ? row["student_name"] : "-"}
                                    onClick={() => history.push(`/studentAdministration/students/open/${row?.student_id}/general`)}
                                >
                                    {row?.student_name ? row["student_name"] : "-"}
                                </p>
                            </div>
                        </div>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        {
            name: "Code",
            selector: "assignmentCode",
            sortable: true,
            sortField: "code",
            cell: (row) => (
                <p className="textLimit76" title={row.assignmentCode}>
                    {row.assignmentCode ? row.assignmentCode : "-"}
                </p>
            ),
        },
        (urlType.includes("Approved") || urlType.includes("Declined")) && {
            name: "Status",
            selector: "ass_submitted_status",
            sortable: true,
            sortField: "ass_submitted_status",
            cell: (row) =>
                row.ass_submitted_status ? (
                    <StatusRender status={"assessment" + row.ass_submitted_status} />
                ) : (
                    "-"
                ),
        },
        {
            name: "Learning Method",
            selector: "study_type",
            sortable: true,
            cell: (row) => (
                <p className="learningMethodText">
                    {row && row.learnType ? RenderLearningMethod(row.learnType).html : "-"}
                </p>
            ),
        },
        {
            name: "Due Date",
            selector: "mark_due_date",
            sortable: true,
            sortField: "markduedate",
            cell: (row) => (
                <>
                    {row.mark_due_date ? (
                        <>
                            <p className="right-space">
                                {moment.unix(row.mark_due_date).format(TABLE_DATE_FORMAT)}
                            </p>
                            <p className="right-space">
                                {moment.unix(row.mark_due_date).format(TABLE_TIME_FORMAT)}
                            </p>
                        </>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        (urlType.includes("Approved") || urlType.includes("Declined")) && {
            name: "Appeal Extended Date",
            selector: "appealExtendedDate",
            sortable: true,

            cell: (row) => (
                <>
                    {row.appealExtendedDate ? (
                        <>
                            <p className="right-space">
                                {moment.unix(row.appealExtendedDate).format(TABLE_DATE_FORMAT)}
                            </p>
                            <p className="right-space">
                                {moment.unix(row.appealExtendedDate).format(TABLE_TIME_FORMAT)}
                            </p>
                        </>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        (urlType.includes("Approved") || urlType.includes("Declined")) && {
            name: "Assessment Uploaded",
            selector: "AssessmentUploaded",
            sortable: true,
            cell: (row) =>
                row && row.AssessmentUploaded ? row.AssessmentUploaded : "-",
        },
        (urlType.includes("Approved") || urlType.includes("Declined")) && {
            name: "Appeal Date",
            selector: "appealDate",
            sortable: true,

            cell: (row) => (
                <>
                    {row.appealDate ? (
                        <>
                            <p className="right-space">
                                {moment.unix(row.appealDate).format(TABLE_DATE_FORMAT)}
                            </p>
                            <p className="right-space">
                                {moment.unix(row.appealDate).format(TABLE_TIME_FORMAT)}
                            </p>
                        </>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        {
            name: "Course",
            selector: "courseName",
            sortable: true,
            sortField: "course",
            cell: (row) => (

                <Link
                    className="as-text-blue curser feature-name"
                    to={`/courseAdministration/coursesdetails/${row.intakeID}/dashboard/show`}
                >
                    <span className="textLimit100">{row.courseName ? row.courseName : "-"}</span>
                </Link>

            ),
        },
        {
            name: "Programme",
            selector: "qualification",
            sortable: true,
            sortField: "qualification",
            cell: (row, index) => (

                <Link
                    className="as-text-blue curser feature-name"
                    to={`/courseAdministration/Programmes/programme/open/${row.qualificationID}/details`}
                >
                    <span className="textLimit100">{row.qualification ? row.qualification : "-"}</span>
                </Link>
            ),
        },
        {
            name: "Intake",
            selector: "intakeYear",
            sortable: true,
            sortField: "intake",
            cell: (row) => (
                <p>
                    {row.intakeYear || row.intakeNumber ? (
                        <>
                            {" "}
                            {row.intakeYear ? row.intakeYear : ""}-{row.intakeNumber ? row["intakeNumber"] : ""}
                        </>
                    ) : (
                        "-"
                    )}
                </p>
            ),
        },
        {
            name: "Marker",
            selector: "MARKER",
            sortable: true,
            sortField: "marker",
            cell: (row) => (
                <>
                    {row.MARKER ? (
                        <div className="assigned-title-block-new">
                            <div className="assigned-title-itm">
                                <span
                                    className={
                                        "assigned-title-blk  name-icon cat-dark-red " +
                                        ColorRender("lecturer")
                                    }
                                >
                                    {row.markerProfile ? (
                                        <img
                                            src={`${IMAGE_URL}/${row.markerProfile.replaceAll(
                                                "/home/myaie/public_html/",
                                                ""
                                            )}`}
                                            alt="AIE"
                                        />
                                    ) : (
                                        InitialRender([
                                            row.MARKER.split(" ")[0],
                                            row.MARKER.replace(/ +/g, " ").split(" ")[1],
                                        ])
                                    )}
                                    <span className={`profile-box-2-status ${row.marker_activity_status ? row.marker_activity_status.toLowerCase() == "online" ? "Online" : row.marker_activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                                        <i className="fas fa-circle"></i>
                                    </span>
                                    <Hover
                                        firstName={row.MARKER.split(" ")[0]}
                                        lastName={row.MARKER.replace(/ +/g, " ").split(" ")[1]}
                                        photo={row.markerProfile}
                                        email={row.markerEmail}
                                        mobile={row.markerMobile}
                                        right={false}
                                        role={"lecturer"}
                                        status={row.marker_status}
                                        activity_status={row.marker_activity_status}
                                    />
                                </span>
                                <p
                                    className="as-text-blue curser textLimit76"
                                    title={row.MARKER ? row["MARKER"] : "-"}
                                    onClick={() =>
                                        history.push(
                                            `/systemAdministration/userManagement/open/${row.MARKERid}/aboutYou`
                                        )
                                    }
                                >
                                    {row.MARKER ? row["MARKER"] : "-"}
                                </p>
                            </div>
                        </div>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        {
            name: "Actions",
            // selector: "Action",
            cell: (row) => (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                        <Link
                            className="btn btn-primary rounded-circle"
                            to={`/courseAdministration/coursesdetails/${row.intakeID}/assessments/open/assigned/submissionsAndResults/${row.assignmentID}/appealList/${row.student_id}`}
                            title="Open"
                        >
                            <i className="fal fa-folder-open"></i>
                        </Link>
                    </div>
                </div>
            ),
        },
    ], []);

    const exportData = (fileType, fileName) => {
        let data;

        const header = [
            "Name",
            "Full Name",
            "Code",
            // "End",
            "Status",
            "Learning Method",
            "Due Date",
            "Appeal Extended Date",
            "Assessment Uploaded",
            "Appeal Date",
            "Course",
            "Programme",
            "Intake",
            "Marker",
        ];

        if (!urlType.includes("Approved") && !urlType.includes("Declined")) {
            header.splice(header.indexOf("Full Name"), 1);
        }
        if (!urlType.includes("Approved") && !urlType.includes("Declined")) {
            header.splice(header.indexOf("Status"), 1);
        }
        if (!urlType.includes("Approved") && !urlType.includes("Declined")) {
            header.splice(header.indexOf("Appeal Extended Date"), 1);
        }
        if (!urlType.includes("Approved") && !urlType.includes("Declined")) {
            header.splice(header.indexOf("Assessment Uploaded"), 1);
        }

        if (!urlType.includes("Approved") && !urlType.includes("Declined")) {
            header.splice(header.indexOf("Appeal Date"), 1);
        }

        Swal.fire({
            title: "File downloading",
            onOpen: function () {
                Swal.showLoading();
            },
        });

        GetAppealslistCancelToken({
            page: tableState.page,
            limit: tableState.perPage,
            viaQualification: programme.arr,
            intake: intake.arr,
            vialearnMethod: learningMethod.arr,
            viaStatus: urlType,
            key: tableState.sortKey,
            globalIntake : filterIntake.newValue?.length > 0 ? filterIntake.newValue : [],
            globalSchool : filterSchool.newValue?.length > 0 ? filterSchool.newValue : [],
            globalLecturer : filterLecturer.newValue?.length > 0 ? filterLecturer.newValue : [],
            globalLearningMethod : filterLearningMethod.newValue?.length > 0 ? filterLearningMethod.newValue : [],
            sort: tableState.sortOrder,
            exportStaus: "true",
            viaSearch: search,
        }).then((res) => {
            data = res.data.result;
            data = data.map((row) => ({
                "Name": row.assignmentName,
                "Full Name": row.student_name ? row.student_name : "-",
                "Code": row.assignmentCode,
                // "End": moment
                //   .unix(row.assignmentDateClose)
                //   .format(TABLE_DATE_TIME_FORMAT),
                Status: row.ass_submitted_status ? row.ass_submitted_status : "-",
                "Learning Method": row.learnType ? RenderLearningMethod(row.learnType).text : "-",
                "Due Date": moment
                    .unix(row.mark_due_date)
                    .format(TABLE_DATE_TIME_FORMAT),
                "Appeal Extended Date": row.appealExtendedDate
                    ? moment.unix(row.appealExtendedDate).format(TABLE_DATE_TIME_FORMAT)
                    : "-",
                "Assessment Uploaded": row.AssessmentUploaded
                    ? row.AssessmentUploaded
                    : "-",
                "Appeal Date": row.appealDate
                    ? moment.unix(row.appealDate).format(TABLE_DATE_TIME_FORMAT)
                    : "-",
                "Course": row.courseName,
                Programme: row.qualification,
                Intake: `${row.intakeYear}-${row.intakeNumber}`,
                Marker: row.MARKER,
            }));

            if (fileType === "csv") {
                const csvString = Papa.unparse({ fields: header, data });
                const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

                const blobURL = window.URL.createObjectURL(blob);

                const anchor = document.createElement("a");
                anchor.download = fileName;
                anchor.href = blobURL;
                anchor.dataset.downloadurl = [
                    "text/csv",
                    anchor.download,
                    anchor.href,
                ].join(":");
                anchor.click();

                setTimeout(() => {
                    URL.revokeObjectURL(blobURL);
                }, 1000);
                Swal.close();
            } else if (fileType === "xlsx") {
                const compatibleData = data.map((row) => {
                    const obj = {};
                    header.forEach((col, index) => {
                        obj[col] = row[col];
                    });
                    return obj;
                });

                let wb = XLSX.utils.book_new();
                let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                    header,
                });
                XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                XLSX.writeFile(wb, `${fileName}.xlsx`);
                Swal.close();
                return false;
            }
            if (fileType === "pdf") {
                const compatibleData = data.map((row) => {
                    if (urlType.includes("Pending")) {
                        return [
                            row["Name"],
                            row["Code"],
                            // row["End"],
                            row["Learning Method"],
                            row["Due Date"],
                            row["Course"],
                            row["Programme"],
                            row["Intake"],
                            row["Marker"],
                        ];
                    }
                    if (urlType.includes("Approved")) {
                        return [
                            row["Name"],
                            row["Full Name"],
                            row["Code"],
                            // row["End"],
                            row["Status"],
                            row["Learning Method"],
                            row["Due Date"],
                            row["Appeal Extended Date"],
                            row["Assessment Uploaded"],
                            row["Appeal Date"],
                            row["Course"],
                            row["Programme"],
                            row["Intake"],
                            row["Marker"],
                        ];
                    }
                    if (urlType.includes("Declined")) {
                        return [
                            row["Name"],
                            row["Full Name"],
                            row["Code"],
                            // row["End"],
                            row["Status"],
                            row["Learning Method"],
                            row["Due Date"],
                            row["Appeal Extended Date"],
                            row["Assessment Uploaded"],
                            row["Appeal Date"],
                            row["Course"],
                            row["Programme"],
                            row["Intake"],
                            row["Marker"],
                        ];
                    }
                });
                const doc = new JsPDF();
                doc.autoTable({
                    head: [header],
                    body: compatibleData,
                    columnStyles: {
                        0: {
                            columnWidth: 15,
                        },
                        1: {
                            columnWidth: 10,
                        },
                        2: {
                            columnWidth: 10,
                        },
                        3: {
                            columnWidth: 10,
                        },
                        4: {
                            columnWidth: 10,
                        },
                        5: {
                            columnWidth: 15,
                        },
                        6: {
                            columnWidth: 10,
                        },
                        7: {
                            columnWidth: 15,
                        },
                        8: {
                            columnWidth: 15,
                        },
                        9: {
                            columnWidth: 15,
                        },
                        10: {
                            columnWidth: 15,
                        },
                        11: {
                            columnWidth: 15,
                        },
                        12: {
                            columnWidth: 15,
                        },
                        13: {
                            columnWidth: 15,
                        },
                    },
                    styles: {
                        minCellHeight: 10,
                        minCellWidth: 5,
                        halign: "left",
                        fontSize: 8,
                    },
                });
                doc.save(`${fileName}.pdf`);
                Swal.close();
                return false;
            }
        });
    };

    const listOfColumns = (col) => {
        let columnData = [];
        let pendingColumn = ["Name", "Code", "End Date", "Learning Method", "Due Date", "Course", "Programme", "Intake", "Marker", "Actions"];
        let ApprovedColumns = [
            "Name",
            "Full Name",
            "Code",
            "End Date",
            "Status",
            "Learning Method",
            "Due Date",
            "Appeal Extended Date",
            "Assessment Uploaded",
            "Appeal Date",
            "Course",
            "Programme",
            "Intake",
            "Marker",
            "Actions"
        ];
        let DeclinedColumns = [
            "Name",
            "Full Name",
            "Code",
            "End Date",
            "Status",
            "Learning Method",
            "Due Date",
            "Appeal Extended Date",
            "Assessment Uploaded",
            "Appeal Date",
            "Course",
            "Programme",
            "Intake",
            "Marker",
            "Actions"
        ];

        let currentColumn = col;

        if (urlType.includes("Approved")) {
            columnData = currentColumn.filter((item) => ApprovedColumns.includes(item.name));


            return columnData;
        }
        if (urlType.includes("Pending")) {
            columnData = currentColumn.filter((item) => pendingColumn.includes(item.name));
            return columnData;
        }
        if (urlType.includes("Declined")) {
            columnData = currentColumn.filter((item) => DeclinedColumns.includes(item.name));

            return columnData;
        }


    }

    return (
        <>
            <div className="tabs-wrap">
                <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                    <li
                        className="nav-item"
                        onClick={() => {
                            history.push("/home/appeals/pending");
                        }}
                    >
                        <a
                            className={`nav-link cursor-pointer ${type === "pending" ? "active" : ""
                                }`}
                            id="pills-tab3"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-tab13"
                            aria-selected="true"
                        >
                            <i className="fa fa-exclamation"></i>Pending
                        </a>
                    </li>
                    <li
                        className="nav-item"
                        onClick={() => {
                            history.push("/home/appeals/approved");
                        }}
                    >
                        <a
                            className={`nav-link cursor-pointer ${type === "approved" ? "active" : ""
                                }`}
                            id="pills-tab2"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-tab12"
                            aria-selected="true"
                        >
                            <i className="fa fa-thumbs-up"></i> Approved
                        </a>
                    </li>

                    <li
                        className="nav-item"
                        onClick={() => {
                            history.push("/home/appeals/declined");
                        }}
                    >
                        <a
                            className={`nav-link cursor-pointer ${type === "declined" ? "active" : ""
                                }`}
                            id="pills-tab1"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-tab11"
                            aria-selected="true"
                        >
                            <i className="fa fa-thumbs-down"></i>
                            Declined
                        </a>
                    </li>
                </ul>
            </div>
            <DataTableComponent
                loading={isLoading}
                data={appealsList}
                columns={listOfColumns(columns)}
                totalRows={totalRows}
                state={tableState}
                setState={setTableState}
                setSearch={setSearch}
                exportFunction={exportData}
                exportFileName="Appeal_List"
                isInsidePopUp
                filters={[
                    {
                        filterName: "Learning Method",
                        optionArr: storedGlobal.learningMethod?.arr.length ? appealDropdown.learningMethod.filter(element => storedGlobal.learningMethod.arr.includes(element.value)) : appealDropdown.learningMethod,
                        state: learningMethod,
                        setState: setLearningMethod,
                        renderLabelFunction: RenderLearningMethod,
                    },
                    {
                        filterName: "Programme",
                        optionArr: appealDropdown.programme,
                        state: programme,
                        setState: setProgramme,
                        isSearchFilter: true
                    },
                    {
                        filterName: "Intake",
                        optionArr: storedGlobal.intake?.arr.length ? appealDropdown.intake.filter(element => storedGlobal.intake.arr.includes(element.value)) : appealDropdown.intake ,
                        state: intake,
                        setState: setIntake,
                        isOptionReversed: true,
                        isIntake: true
                    }
                ]}
            />
        </>
    );
};

export default AppealTable;
